import React from "react";

import classNames from "classnames";
import brand from "@utils/brand";
import { Container } from "@atoms";
import { Carousel, HeadingWIcon, Card } from "@molecules";
import { AppLink } from "@base";

const CarouselCards = ({ icon, heading, copy, cards, small }) => {
  const { lakota, lgca, romero } = brand;

  if (cards && cards.length > 0) {
    return (
      <div
        className={classNames("relative w-full overflow-hidden", {
          "pt-20 pb-24": !romero,
          "bg-white py-12 md:py-24": romero,
          "bg-gray-light": lakota,
          "bg-offwhite": lgca,
        })}
      >
        <Container>
          <div className="relative">
            <HeadingWIcon
              heading={heading}
              copy={copy}
              icon={icon || "turtle"}
              className={classNames({
                "mb-12 lg:mb-16": cards && !romero,
                "mb-8 lg:mb-12": cards && romero,
              })}
              colors={romero ? { heading: "text-blue" } : null}
            />
            {cards.length > 2 && (
              <div className="-mx-3">
                <Carousel
                  showMultiple
                  indicators={false}
                  gradient={romero ? null : "gray"}
                  maxVisible={3}
                  centerItems
                >
                  {cards.map(card => (
                    <div className="px-3">
                      {card.link ? (
                        <AppLink to={`${card.link}`} className="group block">
                          <Card {...card} small={small} />
                        </AppLink>
                      ) : (
                        <div className="group block">
                          <Card {...card} small={small} />
                        </div>
                      )}
                    </div>
                  ))}
                </Carousel>
              </div>
            )}
            {cards.length <= 2 && (
              <div className="-mx-3 flex flex-wrap space-y-6 md:space-y-0">
                {cards.map(card => (
                  <div className="w-full px-3 md:w-1/2">
                    {card.link ? (
                      <AppLink to={`${card.link}`} className="group block">
                        <Card {...card} small={small} />
                      </AppLink>
                    ) : (
                      <div className="group block">
                        <Card {...card} small={small} />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </Container>
      </div>
    );
  }
  return null;
};

CarouselCards.defaultProps = {};

export default CarouselCards;
